// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3SDs6","rootSmall":"AddTileButton_rootSmall__4CKrr"};